import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useIdProvider } from '../hooks/id-provider.js';
import { group, groupInner, title, itemIndent } from './menu-v2.css.js';

/**
 * A visually-related cluster of Menu.Items.
 *
 * @compose { "parent": ["MenuV2.Root", "MenuV2.SubMenu"], "multi": true }
 */
const Group = forwardRef(({ children, title: title$1, ...props }, ref) => {
    const [id, IdProvider] = useIdProvider();
    const isVisibleTitle = !!title$1; // Note: an empty React node is fine for this check
    return (jsx(IdProvider, { value: id, children: jsx("li", { role: "none", className: group, children: jsxs("ul", { "data-fpl-component": "", ...props, "aria-labelledby": (isVisibleTitle && id) || undefined, ref: ref, className: groupInner, role: "group", children: [isVisibleTitle && (jsxs("li", { role: "none", id: id, className: title, children: [jsx("span", { className: itemIndent, "aria-hidden": true }), title$1] })), children] }) }) }));
});
Group.displayName = 'MenuV2.Group';

export { Group };
//# sourceMappingURL=menu-v2.group.js.map
